import { Component, Output, EventEmitter, OnInit, ViewChild, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import moment from 'moment';
import { Utils } from 'app/utils';
import { XpressCalendarEnum } from './xpress-calendar.enum';
import { XpressCalendarFilter} from './xpress-calendar-filter';

@Component({
    providers: [MessageService],
    selector: 'xpress-calendar',
    templateUrl: './xpress-calendar.component.html',
    styleUrls: ['./xpress-calendar.component.scss']
})
export class XpressCalendarComponent implements OnInit {

    public datesList: Array<any> = [
        { name: 'Today', value: XpressCalendarEnum.Today },
        { name: 'Yesterday', value: XpressCalendarEnum.Yesterday },
        { name: 'Last 7 days', value: XpressCalendarEnum.Last7Days },
        { name: 'Last 30 days', value: XpressCalendarEnum.Last30Days },
        { name: 'This Month', value: XpressCalendarEnum.ThisMonth },
        { name: 'Custom', value: XpressCalendarEnum.Custom },
        { name:'',value:''}
    ];

    public selectedDate: XpressCalendarEnum = XpressCalendarEnum.Today;
    public filterObj: XpressCalendarFilter = {
        startDate: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'), // Set default end date
        endDate: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss') // Set default end date
    };

    @ViewChild('datesDropdown')
    datesDropdown!: any;

    @Input()
    initialValue!: XpressCalendarEnum;

    @Input()
    marginLeft: string = '';

    /** When true, presets (Today, Yesterday, etc.) use Philippines calendar days (Asia/Manila). */
    @Input()
    usePhilippinesCalendar: boolean = false;

    @Output()
    public generateHandler = new EventEmitter();

    public showCalendars: boolean = false;

    minDate!: Date;
    maxDate!: Date;

    constructor() { }

    ngOnInit(): void {
        if (this.usePhilippinesCalendar) {
            const phToday = Utils.formatPHCalendarDate(Utils.getPHTodayCalendarDate());
            this.filterObj.startDate = `${phToday}T00:00:00`;
            this.filterObj.endDate = `${phToday}T00:00:00`;
        }

        if (this.initialValue) {
            this.selectedDate = this.initialValue;
            this.onDateChange();
        }

    }

    dblClick(date: Date) {
        this.onDateChange(date);
        this.datesDropdown.hide();
    }

    showCustom(ev: Event){
        this.showCalendars = true;
        const itemList = document.getElementsByClassName('p-dropdown-items-wrapper')[0] as any;
        itemList.style.width = '900px';
        itemList.style.maxWidth = '900px';
        itemList.style.cursor = 'default';
        itemList.addEventListener('click', (e: Event)=> {
            e.stopPropagation();
        });
        const dropdownElems = document.getElementsByTagName('p-dropdownitem') as any;
        const dummy = dropdownElems[dropdownElems.length-1];

        if (dummy && dummy.children[0]) {
            dummy.children[0].id = 'calendar-val';
            dummy.children[0].style.background = 'white';
            dummy.children[0].style.cursor = 'default';
            dummy.style.display = 'block';
            dummy.style.marginTop = '-215px';
            dummy.style.marginLeft = '150px';
        }
        if (this.marginLeft) {
            const itemListParent = document.getElementsByClassName('p-overlay-content')[0] as any;
            itemListParent.style.marginLeft = this.marginLeft;
        }
        const startDatePicker = document.getElementById('customStartDate') as any;
        const endDatePicker = document.getElementById('customEndDate') as any;
        startDatePicker.firstChild.children[0].style.border = 'none';
        endDatePicker.firstChild.children[0].style.border = 'none';
        ev.stopPropagation();
    }

    setDropdownStyle(){
        this.showCalendars = false;
        const dropdownElems = document.getElementsByTagName('p-dropdownitem') as any;
        if (dropdownElems && dropdownElems.length > 1) {
            const custom = dropdownElems[dropdownElems.length-2];
            const dummy = dropdownElems[dropdownElems.length-1];
            if (dummy) {
                dummy.style.display = 'none';
            }
            if (custom) {
                custom.addEventListener('click', (e: Event)=> {
                    //this.showCustom(e);
                    e.stopPropagation();
                });
            }
        }
        const itemList = document.getElementsByClassName('p-dropdown-items-wrapper')[0] as any;
        itemList.style.maxHeight = '';
        itemList.style.maxWidth = '180px';
        itemList.style.overflow = 'hidden';
        const itemListParent = document.getElementsByClassName('p-overlay-content')[0] as any;
        itemListParent.style.width = 'fit-content';
    }

	onDateChange(doubleClickDate: any = null) {
        if (!this.selectedDate || (this.selectedDate === XpressCalendarEnum.Custom && !this.filterObj.startDate && !this.filterObj.endDate)) {
            return;
        }
        const today = this.usePhilippinesCalendar
            ? Utils.getPHTodayCalendarDate()
            : new Date();
        const date = new Date(today.getTime());
        switch (this.selectedDate) {
            case XpressCalendarEnum.Today: {
                const curDay = this.formatCalendarDay(today);
                this.filterObj.startDate = curDay;
                this.filterObj.endDate = curDay;
                break;
            }
            case XpressCalendarEnum.Yesterday: {
                const yesterdayDate = this.usePhilippinesCalendar
                    ? Utils.addCalendarDays(today, -1)
                    : new Date(date.setDate(date.getDate() - 1));
                const yesterday = this.formatCalendarDay(yesterdayDate);
                this.filterObj.startDate = yesterday;
                this.filterObj.endDate = yesterday;
                break;
            }
            case XpressCalendarEnum.Last7Days:
                this.filterObj.startDate = this.formatCalendarDay(
                    this.usePhilippinesCalendar
                        ? Utils.addCalendarDays(today, -6)
                        : new Date(date.setDate(date.getDate() - 6))
                );
                this.filterObj.endDate = this.formatCalendarDay(today);
                break;
            case XpressCalendarEnum.Last30Days:
                this.filterObj.startDate = this.formatCalendarDay(
                    this.usePhilippinesCalendar
                        ? Utils.addCalendarDays(today, -29)
                        : new Date(date.setDate(date.getDate() - 29))
                );
                this.filterObj.endDate = this.formatCalendarDay(today);
                break;
            case XpressCalendarEnum.ThisMonth: {
                const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                this.filterObj.startDate = this.formatCalendarDay(firstDay);
                this.filterObj.endDate = this.formatCalendarDay(today);
                break;
            }
            case XpressCalendarEnum.Custom:
                this.filterObj.startDate = moment(this.filterObj.startDate).format('YYYY-MM-DD');
                this.filterObj.endDate = moment(this.filterObj.endDate).format('YYYY-MM-DD');
                break;
        }

        if (doubleClickDate) {
            const sameDate = moment(doubleClickDate.setDate(doubleClickDate.getDate() + 1)).format('YYYY-MM-DD');
            this.filterObj.startDate = sameDate;
            this.filterObj.endDate = sameDate;
        }

        this.minDate = moment(this.filterObj.startDate).toDate();
        this.maxDate = moment(this.filterObj.endDate).toDate();

        this.generateHandler.emit(this.filterObj);
    }

    refresh() {
        this.selectedDate = XpressCalendarEnum.Custom;
        this.onDateChange();
        this.datesDropdown.hide();
    }

    clear() {
        this.selectedDate = XpressCalendarEnum.Today;
        this.onDateChange();
        this.datesDropdown.hide();
    }

    onStartDateSelected(date: Date) {
        this.minDate = new Date(date);
        this.minDate.setDate(date.getDate());
    }

    onEndDateSelected(date: Date) {
        this.maxDate = new Date(date);
        this.maxDate.setDate(date.getDate());
    }

    private formatCalendarDay(date: Date): string {
        return this.usePhilippinesCalendar
            ? Utils.formatPHCalendarDate(date)
            : moment(date).format('YYYY-MM-DD');
    }
}
